/**
 * List of events used by booking-choice-list widget
 */
export const bookingChoiceList = {
  CHOOSE_PER_PERSON_SWITCH: 'bookingChoiceList.ChoosePerPersonSwitch'
}
